import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material'
import {
  DashboardHistoryTabBar,
  DashboardHistoryTabPanel,
  DashboardHistoryTabKey,
} from './DashboardHistoryTabs'
import { DashboardSignOff, DashboardSignOffRevoked } from '../../types/gotypes'

interface DashboardHistoryModalProps {
  open: boolean
  customer: string
  dashboardId: string
  onClose: () => void
  // Sign-off tab context (#974 H1) — current state comes from the dashboard
  // config the caller already holds; event history is fetched by the panel.
  currentSignOff?: DashboardSignOff
  signOffRevoked?: DashboardSignOffRevoked
  widgetTitles?: Record<string, string>
}

// The dashboard History panel (#974 H1): two tabs — "Text edits" (who changed
// what text, when) and "Sign-offs" (who signed off what, when). The tab is
// called "Text edits" because text edits are literally all it captures; the
// older "Edits" label made people wonder what else had been edited and assume
// something was missing. The editor's Settings -> History tab renders the same
// two sub-tabs from the same components (#974).
const DashboardHistoryModal: React.FC<DashboardHistoryModalProps> = ({
  open,
  customer,
  dashboardId,
  onClose,
  currentSignOff,
  signOffRevoked,
  widgetTitles,
}) => {
  const [tab, setTab] = useState<DashboardHistoryTabKey>('edits')

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ pb: 0 }}>History</DialogTitle>
      <DashboardHistoryTabBar value={tab} onChange={setTab} px={3} />
      <DialogContent dividers sx={{ borderTop: 'none' }}>
        <DashboardHistoryTabPanel
          value={tab}
          active={open}
          customer={customer}
          dashboardId={dashboardId}
          currentSignOff={currentSignOff}
          signOffRevoked={signOffRevoked}
          widgetTitles={widgetTitles}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  )
}

export default DashboardHistoryModal
